<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title">{{ title ? title : "Confirmation" }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div>{{ content }}</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="yes()">{{ confirmBtnText ? confirmBtnText : "Yes" }}</button>
    <button type="button" class="btn btn-secondary" (click)="close()">
      {{ cancelBtnText ? cancelBtnText : "No" }}
    </button>
  </div>
</div>
